import {
    SAVE_ANNOUNCEMENTS_DATA,
    GET_ANNOUNCEMENTS_DATA,
  } from "../actions/types";

  const INITIAL_STATE = {
    announcementsList: [],
  };

  export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case GET_ANNOUNCEMENTS_DATA:
        return {
          ...state,
          announcementsList: action.payload,
        };
      case SAVE_ANNOUNCEMENTS_DATA:
        return {
          ...state,
          announcementsList:[...state.announcementsList].concat(action.payload)
        };
      default:
        return state;
    }
  };
  